import { combineReducers } from 'redux';
import { createReducer } from '../utils';

/* ActionTypes */
const TOGGLE_DUPLICATION_MODE = 'TOGGLE_DUPLICATION_MODE';
const TOGGLE_ENTITY_TO_DUPLICATE = 'TOGGLE_ENTITY_TO_DUPLICATE';

/* Actions */
function doToggleDuplicationMode() {
	return {
		type: TOGGLE_DUPLICATION_MODE
	};
}

function doToggleEntityToDuplicate(entityReducerKey, id) {
	return {
		type: TOGGLE_ENTITY_TO_DUPLICATE,
		entityReducerKey,
		id
	};
}

/* Reducers */
const duplicationMode = createReducer(false, {
	[TOGGLE_DUPLICATION_MODE]: (state, action) => !state
});

const initialState = {
	lockingsIds: {},
	rolesIds: {}
};

const entitiesToDuplicate = createReducer(initialState, {
	[TOGGLE_ENTITY_TO_DUPLICATE]: (state, action) => {
		const isActive = state[action.entityReducerKey][action.id];
		return {
			...state,
			[action.entityReducerKey]: {
				...state[action.entityReducerKey],
				[action.id]: isActive ? false : true
			}
		};
	}
});

const reducer = combineReducers({
	duplicationMode,
	entitiesToDuplicate
});

/* Selectors */
function getDuplicationMode(state) {
	return state.app.duplication.duplicationMode;
}

function getEntitiesToDuplicate(state) {
	return state.app.duplication.entitiesToDuplicate;
}

export default reducer;
export {
	doToggleDuplicationMode,
	doToggleEntityToDuplicate,
	getDuplicationMode,
	getEntitiesToDuplicate
};



// WEBPACK FOOTER //
// ./src/js/reducers/app/duplication.js